import { RecordBase } from '../../providers/request/record-base.model';
import { JgInspType } from './jg-insp-type.enum';
export class JgInspSolution extends RecordBase {
  projectId?: number;
  jgSectionId?: number;
  sectionId?: number;
  organizationId?: number;
  jgInspTypes?: Array<JgInspType>;
  jgInspTypesDisplay?: string;
  name?: string;
  fileId?: string;
  fileSn?: string;
  fileName?: string;
  fileMd5?: string;
  uploadTime?: number;
  comment?: string;
}
